<template>
  <v-dialog v-model="show" width="40vw" scrollable>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        Fecha de resultados
      </v-card-title>
      <v-card-text> </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn color="gray" dark block @click="show = false">
                Cerrar
              </v-btn>
            </v-col>
            <v-col>
              <v-btn color="primary" block @click="show = false">
                Aceptar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    value: Boolean,
    guide: Object,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    show(value) {
      if (value) {
        // DIALOG OPEN
      } else {
        // DIALOG CLOSE
      }
    },
  },
};
</script>